import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EEAOutputProjectSummaryResultSurfaceWaterApiService, EraSmeSelectionStatus } from '../../services/out-put-project/eea-output-project-step1n2-summary-result.api.service';
import { Constants } from '../../utils/constants';

export interface StepStatus {
  label: string;
  selected: boolean;
  errorMessage?: string;
}

export function createStepStatuses(): StepStatus[] {
  return [
    { label: Constants.SCENARIO_FOCUS.STEP1, selected: false },
    { label: Constants.SCENARIO_FOCUS.STEP2, selected: false },
    { label: Constants.SCENARIO_FOCUS.STEP3, selected: false },
    { label: Constants.SCENARIO_FOCUS.STEP4, selected: false }
  ];
}

@Component({
  selector: 'sme-status-section',
  templateUrl: './sme-status-section.component.html',
  styleUrls: ['./sme-status-section.component.css']
})
export class SmeStatusSectionComponent implements OnInit {
  @Input() projectPk?: number;
  @Output() statusesChange = new EventEmitter<StepStatus[]>();

  stepStatuses: StepStatus[] = createStepStatuses();

  constructor(private surfaceWaterApiService: EEAOutputProjectSummaryResultSurfaceWaterApiService) {}

  ngOnInit(): void {
    if (!this.projectPk) return;

    this.surfaceWaterApiService.getEraSmeSelectionStatus(this.projectPk).subscribe({
      next: (statuses: EraSmeSelectionStatus[]) => {
        const selectedSteps = new Set(statuses.map(s => s.scenarioFocus));
        this.stepStatuses.forEach(step => step.selected = selectedSteps.has(step.label));
        this.applyStepDependencyValidation();
        this.statusesChange.emit(this.stepStatuses);
      },
      error: () => {}
    });
  }

  private applyStepDependencyValidation(): void {
    const step3 = this.stepStatuses.find(s => s.label === Constants.SCENARIO_FOCUS.STEP3);
    const step4 = this.stepStatuses.find(s => s.label === Constants.SCENARIO_FOCUS.STEP4);
    if (step3 && step4 && step4.selected && !step3.selected) {
      step3.errorMessage = 'You must save Step3 PECs before send Step4';
    } else if (step3) {
      step3.errorMessage = undefined;
    }
  }
}
